/**
 * Back Navigation Module
 * Handles back links with section memory
 */

export function initBackNavigation(): void {
  const backLink = document.querySelector<HTMLAnchorElement>('.back-nav__link');
  if (!backLink) return;

  // Determine which section this page belongs to
  const path = window.location.pathname;
  let section = '';

  if (path.includes('/stolperstein/')) {
    section = 'stolpersteine';
  } else if (path.includes('/medienprojekt/')) {
    section = 'medienprojekte';
  } else if (path.includes('/filmproduktion/')) {
    section = 'projektdokumentation';
  }

  // Update back link to include section parameter
  if (section) {
    const currentHref = backLink.getAttribute('href') || '../';
    backLink.setAttribute('href', `${currentHref}?returnTo=${section}`);
  }
}

/**
 * Handle Return Scroll on Main Page
 * Scrolls to the section the user came from
 */
export function handleReturnScroll(): void {
  // Only run on main page
  const isMainPage = window.location.pathname.endsWith('/') ||
                     window.location.pathname.endsWith('/index.html');

  if (!isMainPage) return;

  // Check for returnTo parameter
  const urlParams = new URLSearchParams(window.location.search);
  const returnTo = urlParams.get('returnTo');

  // Map section names to element ids
  const sectionMap: Record<string, string> = {
    'stolpersteine': 'stolpersteine',
    'medienprojekte': 'medienprojekte',
    'projektdokumentation': 'projektdokumentation',
    'interview': 'interview'
  };

  // Hash fragment (e.g. index.html#spenden from a subpage) or returnTo parameter
  let targetId: string | null = null;
  if (returnTo && sectionMap[returnTo]) {
    targetId = sectionMap[returnTo];
  } else if (window.location.hash.length > 1) {
    targetId = decodeURIComponent(window.location.hash.slice(1));
  }

  if (!targetId) return;

  const targetElement = document.getElementById(targetId);
  if (!targetElement) return;

  // Der Browser springt beim Laden schon zum Anker, bevor die Inhalte gerendert sind
  // und das Layout steht -> danach landet man zu weit oben. Deshalb hart nachjustieren,
  // mehrfach ueber kurze Zeit, bis das Layout stabil ist (wie in scroll-memory.ts).
  const rootStyle = document.documentElement.style;
  const prevBehavior = rootStyle.scrollBehavior;
  rootStyle.scrollBehavior = 'auto';

  let cancelled = false;
  const cancel = (): void => { cancelled = true; };
  const userEvents = ['wheel', 'touchstart', 'keydown', 'mousedown'] as const;
  userEvents.forEach(evt => window.addEventListener(evt, cancel, { once: true, passive: true }));

  const jump = (): void => {
    if (!cancelled) targetElement.scrollIntoView({ block: 'start' });
  };

  jump();
  requestAnimationFrame(jump);
  setTimeout(jump, 150);
  setTimeout(jump, 400);
  const onLoad = (): void => {
    jump();
    setTimeout(() => {
      jump();
      rootStyle.scrollBehavior = prevBehavior;
      userEvents.forEach(evt => window.removeEventListener(evt, cancel));
    }, 100);
  };
  if (document.readyState === 'complete') {
    onLoad();
  } else {
    window.addEventListener('load', onLoad, { once: true });
  }

  // returnTo-Parameter aus der URL entfernen, Hash behalten
  if (returnTo) {
    window.history.replaceState({}, '', window.location.pathname + window.location.hash);
  }
}
